import { tokens } from "../../../styles/theme";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import * as sweetalert from "sweetalert";

import {
  GridRowModes,
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import { Grid, TextField } from "@material-ui/core";

import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
 
  return (
    <>
      <GridToolbarContainer>

      </GridToolbarContainer>

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport csvOptions={{
          fileName: "كشف الحساب",
          utf8WithBom: true,
        }}/>
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Account = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [Test, setTest] = useState('');

  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [mobile_number, setMobile_number] = useState('');

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };
  const handleGetRowId = (e) => {
       var length = 8,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const handeleInput = (e) => {
    e.persist();
    setMobile_number({ ...mobile_number, [e.target.name]: e.target.value });
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleSearch = ()=>{
    
    axios
    .post(`${BaseUrl}/api/getAccountStatement`, mobile_number, {
      withCredentials: true,
    })
    .then((res) => {
      
     if(res.data.status == true){
       const user=res.data.data;
       setTest(user);
      }
      else{
        sweetalert("رقم الموبايل غير موجود", {
          className: "alert-div",
          button: {
            text: "تم",
          },
        });
        window.Location.reload();
      }
      
    });

    
  }
  useEffect(()=>{

  },[Test])
  const columns = [
    {
      field: "name",
      headerName: "اسم المستخدم",
      headerAlign: "center",
      align: "center",
      editable: false,
      flex:1,
    },
    {
      field: "mobile_number_deal_with",
      headerName: "رقم  صاحب كشف الحساب",
      headerAlign: "center",
      align: "center",
      editable: false,
      flex:1,
    },
    {
      field: "person_deal_with",
      headerName: "اسم العميل",
      headerAlign: "center",
      align: "center",
      editable: false,
      flex:1,
    },
    {
      field: "mobile_number",
      headerName: "رقم العميل",
      headerAlign: "center",
      align: "center",
      editable: false,
      flex:1,
    },
    {
      field: "type",
      headerName: "النوع",
      headerAlign: "center",
      align: "center",
      editable: false,
      flex:1,
    },
    {
      field: "amount",
      headerName: "قيمة العملية",
      headerAlign: "center",
      align: "center",
      editable: false,
      flex:1,
    },
    {
      field: "amount_before",
      headerName: "الرصيد قيل",
      headerAlign: "center",
      align: "center",
      type: "number",
      editable: false,
      flex:1,
    },
    {
      field: "amount_after",
      headerName: "الرصيد بعد",
      headerAlign: "center",
      align: "center",
      type: "number",
      editable: false,
      flex:1,
    },
    {
      field: "date",
      headerName: "التاريخ",
      headerAlign: "center",
      align: "center",
      type: "number",
      editable: false,
      flex:1,
      valueFormatter: (params) =>
      moment(params?.value).format("MMMM DD YYYY -H:mma "),
    },

   
  ];
  return (
    <Box m="2px 5px 0px 5px">
      <Grid item lg={12} md={12} sm={12} style={{display:'flex',marginTop:'20px', justifyContent:'center',alignItems:'center'}}>
        <Grid item lg={2} md={2} sm={2}>
          <label className="search-account">ابحث عن طريق رقم الهاتف</label>
          <TextField
                    className="form-control"
                    fullWidth
                    required
                    type="text"
                    margin="normal"
                    name="mobile_number"
                    onChange={handeleInput}
                    sx={{
                      "& .MuiInputLabel-root": { fontSize: "1rem" },

                      "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                    }}
                  />
          </Grid>
        <Grid item lg={2} md={2} sm={2} style={{marginRight:'20px'}}>
                  <Button
                  type="submit"
                  style={{
                    backgroundColor: "#297FB8",
                    fontSize: "18px",
                    color: "#fff",
                    margin: "20px 0",
                  }}
                  variant="contained"
                  onClick={handleSearch}
                >
                بحث
                </Button>
        </Grid>
          </Grid>
     
    
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
   
        <DataGridPro
          rows={Test}
          className="field-table"
          columns={columns}
          editMode="row"
          getRowId={handleGetRowId}
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,}}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'عنوان العمود',
        }}
          locale='ar-AE'
        />
      </Box>
    </Box>
  );
};

export default Account;
